<template>
  <a
    v-if="to.startsWith('mailto:')"
    :href="to"
    class="btn"
    :class="`btn--${variant}`"
    target="_blank"
    rel="noopener noreferrer"
  >
    <slot></slot>
  </a>
  <router-link
    v-else-if="to"
    :type="type"
    :to="to"
    class="btn"
    :class="`btn--${variant}`"
    @click="handleClick"
  >
    <slot></slot>
  </router-link>
  <button
    v-else
    :type="type"
    class="btn"
    @click="handleClick"
    :class="`btn--${variant}`"
  >
    <slot></slot>
  </button>
</template>

<script setup>
const props = defineProps({
  type: {
    type: String,
    default: "primary", // Default to a standard button
  },
  to: {
    type: String,
    default: "", // For links or email buttons
  },
  scrollTo: {
    type: String,
    default: "", // ID of the section to scroll to
  },
  variant: {
    type: String,
    default: "primary", // Button style variant
  },
});
const handleClick = (event) => {
  if (props.scrollTo) {
    event.preventDefault();
    console.log("clicked");
    const target = document.querySelector(props.scrollTo);
    if (target) {
      target.scrollIntoView({ behavior: "smooth" });
    }
  }
};
</script>

<style lang="scss">
button {
  background-color: transparent;
  display: inline-block;
  padding: 1em 1.75em;
  font-size: 1rem;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: "Raleway", sans-serif;
  white-space: nowrap;
  width: 100%;

  @media (min-width: 500px) {
    width: fit-content;
  }
}
.btn {
  display: inline-block;
  padding: 1em 1.75em;
  font-size: 1rem;
  font-weight: 520;
  text-align: center;
  text-decoration: none;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  white-space: nowrap;
  width: 100%;
  a {
    padding: 0;
  }
  @media (min-width: 500px) {
    width: fit-content;
  }
}
.btn--primary {
  background-color: $bg--col--07;
  color: $text--greyed;
  border: 2px solid $btn--border;
  cursor: pointer;
  @media (min-width: 768px) {
    &:hover {
      background-color: $btn--border;
      color: $text--col;
    }
  }
  &:active {
    background-color: $text--muted;
    color: $text--col;
  }
}
.btn--emphasized {
  background-color: $text--col;
  color: $bg--col;
  border: 2px solid $text--muted;
  font-weight: 550;
  cursor: pointer;
  @media (min-width: 768px) {
    &:hover {
      background-color: $brand--col--light;
    }
  }
  &:active {
    background-color: $brand--col--dark;
  }
}
</style>
